import { BaseModel } from "sjs-base-model";

export default class InfluencerPutModel extends BaseModel {
  //USER PUT model
  data = {};
  status = "";

  constructor(data1) {
    super();

    this.update(data1);
  }
}
